<script>
  import { HorizontalBar } from "vue-chartjs";
  import { mapGetters } from 'vuex'
  export default {
    extends: HorizontalBar,
    name: "TherapistChart",
    computed: {
      ...mapGetters(['therapists_chart']),
    },
    watch: {
      'therapists_chart': {
        handler: function () {
          this.renderTherapistChart();
        },
        deep: true
      }
    },
    mounted() {
      this.renderTherapistChart();
    },
    methods: {
      renderTherapistChart() {
        this.renderChart(
          {
            labels: Object.keys(this.therapists_chart),
            datasets: [
              {
                label: "売上（¥)",
                backgroundColor: "rgb(86 188 218)",
                hoverBackgroundColor: "rgb(86 188 218)",
                data: Object.values(this.therapists_chart)
              }
            ],
          },
          {
            legend: {
              position: 'top'
            },
            responsive: true,
            maintainAspectRatio: false
          }
        );
      }
    }
  }
</script>

<style scoped>

</style>
